module.exports = __webpack_public_path__ + "static/thank-you-d50676e97f99cda4ba9adb7883f4ab88.png";